import React from 'react';
import { Link } from 'react-router-dom';
import { Gavel, Mail, MapPin, Facebook, Twitter, Instagram } from 'lucide-react';

export const Footer = () => {
    return (
        <footer className="bg-white border-t border-border mt-auto" data-testid="footer">
            <div className="container mx-auto px-4 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div className="space-y-4">
                        <Link to="/" className="flex items-center gap-2 font-heading font-bold text-xl">
                            <div className="w-8 h-8 rounded-xl bg-primary flex items-center justify-center">
                                <Gavel className="w-5 h-5 text-white" />
                            </div>
                            <span>Colectarium</span>
                        </Link>
                        <p className="text-muted-foreground text-sm leading-relaxed">
                            Marketplace-ul colecționarilor. Licitații și vânzări directe pentru faleristică, numismatică și obiecte de colecție.
                        </p>
                        <div className="flex items-center gap-3">
                            <a href="#" className="w-9 h-9 rounded-full bg-gray-100 hover:bg-primary hover:text-white flex items-center justify-center transition-colors">
                                <Facebook className="w-4 h-4" />
                            </a>
                            <a href="#" className="w-9 h-9 rounded-full bg-gray-100 hover:bg-primary hover:text-white flex items-center justify-center transition-colors">
                                <Twitter className="w-4 h-4" />
                            </a>
                            <a href="#" className="w-9 h-9 rounded-full bg-gray-100 hover:bg-primary hover:text-white flex items-center justify-center transition-colors">
                                <Instagram className="w-4 h-4" />
                            </a>
                        </div>
                    </div>

                    {/* Categorii */}
                    <div>
                        <h4 className="font-heading font-semibold mb-4">Categorii</h4>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/category/faleristica" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Faleristică
                                </Link>
                            </li>
                            <li>
                                <Link to="/category/numismatica" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Numismatică
                                </Link>
                            </li>
                            <li>
                                <Link to="/category/efecte-militare" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Militare
                                </Link>
                            </li>
                            <li>
                                <Link to="/category/diverse" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Diverse
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Link-uri utile */}
                    <div>
                        <h4 className="font-heading font-semibold mb-4">Link-uri utile</h4>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/despre-noi" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Despre noi
                                </Link>
                            </li>
                            <li>
                                <Link to="/cum-functioneaza" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Cum funcționează
                                </Link>
                            </li>
                            <li>
                                <Link to="/termeni" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Termeni și condiții
                                </Link>
                            </li>
                            <li>
                                <Link to="/confidentialitate" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Politica de confidențialitate
                                </Link>
                            </li>
                            <li>
                                <Link to="/ajutor" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Ajutor
                                </Link>
                            </li>
                            <li>
                                <Link to="/cookie-policy" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                                    Politica de Cookies
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-heading font-semibold mb-4">Contact</h4>
                        <ul className="space-y-3">
                            <li className="text-sm text-foreground font-medium">
                                Călin Miclăuș
                            </li>
                            <li className="flex items-center gap-2 text-sm text-muted-foreground">
                                <Mail className="w-4 h-4 text-primary" />
                                <span>contact@colectarium.ro</span>
                            </li>
                            <li className="flex items-start gap-2 text-sm text-muted-foreground">
                                <MapPin className="w-4 h-4 text-primary mt-0.5" />
                                <span>Arad, România</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-sm text-muted-foreground">
                        © {new Date().getFullYear()} Colectarium. Toate drepturile rezervate.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
